module.exports = __webpack_public_path__ + "img/206.f9c56900.jpg";